import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import SectionHeading from "../SectionHeading";

const fadeUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-60px" },
    transition: { duration: 0.6 },
};

export default function AboutStory() {
    return (
        <section className="py-24 lg:py-32">
            <div className="xpo-container grid lg:grid-cols-2 gap-14 items-start">
                <SectionHeading
                    overline="Our story"
                    title="Started by traders. Run by traders."
                    description="XPO Markets was founded by a small team of currency and crypto traders who were tired of paying for marketing instead of execution. We rebuilt the broker stack around the only thing that actually matters: filling orders fast, fairly, and at the price you saw."
                />
                <motion.div {...fadeUp} className="xpo-glass p-8 lg:p-10 relative">
                    <Quote
                        className="text-[#A6E3DC]/30 absolute top-6 right-6"
                        size={48}
                    />
                    <p className="text-white text-lg leading-relaxed">
                        "We are not building the loudest broker. We are
                        building the one a quant or a swing trader would
                        actually choose if they read the small print."
                    </p>
                    <div className="mt-6 pt-6 border-t border-white/10">
                        <p className="text-white font-semibold text-sm">
                            Co-founders, XPO Markets
                        </p>
                        <p className="text-slate-500 text-xs mt-1">
                            Operating since 2024
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
